import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../links/Link/Link';
import Container from '../../layout/Container/Container';
import CallToActionLink from '../../links/CallToActionLink/CallToActionLink';

/**
 * A component for displaying landing page information
 */
function HeroBanner({ href, source, alt, title, subtitle, linkText, text, children }) {
  return (
    <div className="hero-banner">
      <div className="hero-banner__img">
        {href ? (
          <Link href={href}>
            <img src={source} alt={alt} />
          </Link>
        ) : (
          <img src={source} alt={alt} />
        )}
      </div>
      <div className="hero-banner__cta">
        <Container>
          {title && <div className="cta__title">{title}</div>}
          {subtitle && <p className="cta__subtitle">{subtitle}</p>}
          {href && (
            <CallToActionLink size="large" href={href}>
              {linkText}
            </CallToActionLink>
          )}
          {text && <p className="cta__text">{text}</p>}
          {children}
        </Container>
      </div>
    </div>
  );
}

HeroBanner.propTypes = {
  /**
   * The target of the banner
   */
  href: PropTypes.string,
  /**
   * The image source
   */
  source: PropTypes.string,
  /**
   * The alternative text of the image
   */
  alt: PropTypes.string,
  /**
   * The title of the banner
   */
  title: PropTypes.string,
  /**
   * The subtitle of the banner
   */
  subtitle: PropTypes.string,
  /**
   * The text for the call to action link
   */
  linkText: PropTypes.string,
  /**
   * The text of the banner
   */
  text: PropTypes.string
};

export default HeroBanner;
